import { handleActions } from 'redux-actions';
import {
  getDocumentDetails,
  setDocumentsDetails,
  getReadDocument,
  documentFailure,
  getDocumentPath,
  setCollapse,
  setSelectedContacts,
  getDocumentValue,
  setModifyContact,
  setNavigationPane,
  refreshPath,
  documentSuccessUpload,
  setUploadDocuments,
  getActiveDocument,
  setSelectNewDocument,
  getPathName,
  goBackClientDocument,
  setClientDocument,
  setRefreshUpload,
  setEmailToContactsOnPublish,
  setDocumentsView,
} from '../actions/documentActions';

const defaultState = {
  documentDtails: null,
  documentsDetails: [],
  readDocument: null,
  failure: null,
  documentUpload: null,
  path: null,
  isCollapse: false,
  selectedContacts: [],
  isModifyContact: false,
  isNavigationPane: true,
  isRefreshPath: false,
  valueDocument: null,
  activeDocument: null,
  uploadDocuments: [],
  openNewDocument: false,
  pathName: '',
  isBackClientDocument: false,
  isClientDocument: false,
  refreshUpload: false,
  emailToContactsOnPublish: true,
  documentsView: '',
};

export default handleActions(
  {
    [getDocumentDetails](state, action) {
      return { ...state, documentDtails: action.payload };
    },
    [setDocumentsDetails](state, action) {
      return { ...state, documentsDetails: action.payload };
    },
    [getReadDocument](state, action) {
      return { ...state, readDocument: action.payload };
    },
    [documentFailure](state, action) {
      return { ...state, failure: action.payload };
    },
    [getDocumentPath](state, action) {
      return { ...state, path: action.payload };
    },
    [getPathName](state, action) {
      return { ...state, pathName: action.payload };
    },
    [setCollapse](state, action) {
      return { ...state, isCollapse: action.payload };
    },
    [setSelectedContacts](state, action) {
      return { ...state, selectedContacts: action.payload };
    },
    [getDocumentValue](state, action) {
      return { ...state, valueDocument: action.payload };
    },
    [setModifyContact](state, action) {
      return { ...state, isModifyContact: action.payload };
    },
    [setNavigationPane](state, action) {
      return { ...state, isNavigationPane: action.payload };
    },
    [refreshPath](state, action) {
      return { ...state, isRefreshPath: action.payload };
    },
    [documentSuccessUpload](state, action) {
      return { ...state, documentUpload: action.payload };
    },
    [getActiveDocument](state, action) {
      return { ...state, activeDocument: action.payload };
    },
    [setUploadDocuments](state, action) {
      return { ...state, uploadDocuments: action.payload };
    },
    [setSelectNewDocument](state, action) {
      return { ...state, openNewDocument: action.payload };
    },
    [goBackClientDocument](state, action) {
      return { ...state, isBackClientDocument: action.payload };
    },
    [setClientDocument](state, action) {
      return { ...state, isClientDocument: action.payload };
    },
    [setRefreshUpload](state, action) {
      return { ...state, refreshUpload: action.payload };
    },
    [setEmailToContactsOnPublish](state, action) {
      return { ...state, emailToContactsOnPublish: action.payload };
    },
    [setDocumentsView](state, action) {
      return { ...state, documentsView: action.payload };
    },
  },
  defaultState
);
